import { Navigate, useSearchParams } from "react-router";

import { legacySettingsTabTarget } from "~/settings/feature/settings-entries";

/** /settings lands on Profile; a retired `?tab=` link lands on the page that tab became. */
export function SettingsIndexRedirect() {
  const [searchParams] = useSearchParams();
  return <Navigate to={legacySettingsTabTarget(searchParams.get("tab"))} replace />;
}
